import React from 'react';
import { useSpacesDetails } from './hooks/SpacesDetails.hook';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isMexico } from '@/helpers/locationHelpers';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import SpacesDetailsView from './views/SpacesDetailsView';
import LoadingComponent from '@/components/general/Loading/LoadingComponent';

const SpacesDetailsController = () => {
  const currencyData = useSelector(state => state.currency);
  const location = useSelector(state => state.location?.data);
  const languageData = useSelector(state => state.lenguage?.lang);

  const isFromMexico = isMexico(location);

  const {
    isLoading,
    spacesDataFromBackend,
    coordinatesForMapCenter,
    commentsData,
    onClickMarkers,
    openSignInModal,
    isSignInModalIsOpen,
    closeSignInModal,
    closeWarningModal,
    isWarningModalIsOpen,
    loginWithGoogleOAuth,
    goToWorkspaceMap,
    handleSubmit,
  } = useSpacesDetails();

  const handleGoogleLogin = async ({ email, googleToken }) => {
    return loginWithGoogleOAuth({ username: email, googleToken });
  };

  if (isLoading) {
    return <LoadingComponent loading={isLoading} />;
  }

  return (
    <FlexContainer className={'flex-column width100'}>
      <SpacesDetailsView
        spacesDataFromBackend={spacesDataFromBackend}
        spaceComments={commentsData}
        coordinatesForMapCenter={coordinatesForMapCenter}
        onClickMarkers={onClickMarkers}
        isSignInModalIsOpen={isSignInModalIsOpen}
        closeSignInModal={closeSignInModal}
        openSignInModal={openSignInModal}
        closeWarningModal={closeWarningModal}
        isWarningModalIsOpen={isWarningModalIsOpen}
        onGoogleLogin={handleGoogleLogin}
        goToWorkspaceMap={goToWorkspaceMap}
        handleSubmit={handleSubmit}
        languageData={languageData}
        currencyData={currencyData}
      />
    </FlexContainer>
  );
};

export default SpacesDetailsController;
